module.exports = __webpack_public_path__ + "static/viernes-30-10-51215a7065eb77106e1f88122eac3810.jpg";